import { Store } from '@ngrx/store';
import { environment } from './../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import {
  AppErrors,
  ErrorMsgComponent,
} from '@fitness-force/errors';

import {
  matchValidator,
} from '@fitness-force/shared';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AuthSevices } from 'libs/api/src/lib/auth.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { COMPANY_INFO } from '../../../state/app.state';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { LANGUAGE } from '@fitness-force/models';
import { SELECT_LANGUAGE } from '../../../state/actions';
import { AppInitService, ToastMessageService } from '@fitness-force/api';

import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'fitness-force-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    ErrorMsgComponent,
    TranslateModule,
    SelectModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    AvatarModule
],
})
export class ForgotpasswordComponent implements OnInit, OnDestroy {
  step = new BehaviorSubject('step-1');
  forgotPasswordForm: UntypedFormGroup = new UntypedFormGroup({});
  newPasswordForm: UntypedFormGroup = new UntypedFormGroup({});
  recoveryPasswrodLookupData: any;
  errMsg = null;
  changedPassError: any = null;
  emailSentSuccess = false;
  passwordChangedSuccess = false;
  passwordValidationData: any = null;
  passwordRules: any = [];
  confPasswordRules: any = [];
  public companyInfoDetail$!: Observable<any>;
  companyDetails: any;
  selectedCountry: any;
  showSupportPopup = false;
  isFormSubmitting = false;

  countries = [
    { name: 'Eng', code: 'gb' },
    { name: 'Ar', code: 'sa' }
  ];
  features = [
    {
      date: '20 Aug 21',
      title: 'New personalisation options available on CRM.',
      text: 'Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better.',
    },
    {
      date: '20 Aug 21',
      title: 'New personalisation options available on CRM.',
      text: 'Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better.Your CRM now comes equipped with new personalisation options that help you convert better. Your CRM now comes equipped with new personalisation options that help you convert better.',
    }
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    public translate: TranslateService,
    public appInit: AppInitService,
    private authService: AuthSevices,
    private store: Store,
    private toastService:ToastMessageService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.forgotPasswordForm = new UntypedFormGroup({
      userForgotenInput: new UntypedFormControl('', {
        validators: [Validators.required, Validators.email],
        updateOn: 'change'
      }),
    });

    // Transform email to lowercase on value changes
    this.forgotPasswordForm.get('userForgotenInput')?.valueChanges.subscribe((value: string) => {
      if (value) {
        const lowercaseValue = value.toLowerCase();
        if (lowercaseValue !== value) {
          this.forgotPasswordForm.patchValue({ userForgotenInput: lowercaseValue }, { emitEvent: false });
        }
      }
    });

    this.newPasswordForm = this.fb.group({
      otpcode: [
        '',
        [Validators.required, Validators.maxLength(6), Validators.minLength(6)]
  ],
      newpasswordInput: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(250),
          matchValidator('newpasswordMatchInput', true)
  ]
  ],
      newpasswordMatchInput: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(250),
          matchValidator('newpasswordInput')
  ]
  ],
    });
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.companyDetails = responseData;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }

  get UserForgotenInput(): UntypedFormControl {return this.forgotPasswordForm.get('userForgotenInput') as UntypedFormControl;
  }

  get Otpcode(): UntypedFormControl {return this.newPasswordForm.get('otpcode') as UntypedFormControl;}

  get NewpasswordInput(): UntypedFormControl {
    return this.newPasswordForm.get('newpasswordInput') as UntypedFormControl;
  }
  get NewpasswordMatchInput(): UntypedFormControl {
    return this.newPasswordForm.get('newpasswordMatchInput') as UntypedFormControl;
  }

  validateUserInput(userinput: UntypedFormGroup): void {
    const userData = {
      email_id: userinput.value.userForgotenInput,
      company_uuid: this.companyDetails.compDetails.uuid,
    };
    this.isFormSubmitting = true;
    this.authService.sendForgotPasswordEmail(userData, environment.BASE_URL)
      .subscribe({
        next: (data: any) => {
          this.isFormSubmitting = false;
          this.recoveryPasswrodLookupData = data;
          this.step.next('step-2');
          this.validateUID();
        },
        error: (error: AppErrors) => {
          this.isFormSubmitting = false;
          this.toastService.showError(error);
          this.cd.detectChanges();
        },
      });
  }

  validateUID(): void {
    const userData = {
      unique_Identifier: this.recoveryPasswrodLookupData.unique_request_id,
      company_uuid: this.companyDetails.compDetails.uuid,
    };
    this.authService
      .sendUniqueIndetifierEmail(
        userData,
        this.recoveryPasswrodLookupData.staff_id,
        environment.BASE_URL
      )
      .subscribe({
        next: (data: any) => {
          this.passwordValidationData = data;
          //this.setPasswordValidation()
          setTimeout(() => {
            this.emailSentSuccess = false;
          }, 3000);
        },
        error: (error: AppErrors) => {
          this.toastService.showError(error);
          this.cd.detectChanges();
        },
      });
  }
  setPasswordValidation(): void {
    this.passwordRules = [];
    this.confPasswordRules = [];
    if (this.passwordValidationData) {
      if (
        this.passwordValidationData.min_length &&
        this.passwordValidationData.max_length
      ) {
        this.passwordRules = [
          Validators.required,
          Validators.minLength(this.passwordValidationData.min_length),
          Validators.maxLength(this.passwordValidationData.max_length),
          matchValidator('newpasswordMatchInput', true)
  ];
        this.confPasswordRules = [
          Validators.required,
          Validators.minLength(this.passwordValidationData.min_length),
          Validators.maxLength(this.passwordValidationData.max_length),
          matchValidator('newpasswordInput', false)
  ];
      } else {
        this.passwordRules = [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(250),
          matchValidator('newpasswordMatchInput', true)
  ];
        this.confPasswordRules = [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(250),
          matchValidator('newpasswordInput', false)
  ];
      }
      if (this.passwordValidationData.min_spl_chars) {
        //this.passwordRules.push(SpecialCharacterCheck(this.NewpasswordInput))
      }
      if (this.passwordValidationData.min_numeric_chars) {
        //this.passwordRules.push(SpecialCharacterCheck(this.NewpasswordInput))
      }
      this.newPasswordForm.controls['newpasswordInput'].setValidators(
        this.passwordRules
      );
      this.newPasswordForm.controls['newpasswordMatchInput'].setValidators(
        this.passwordRules
      );
      this.newPasswordForm.controls[
        'newpasswordInput'
      ].updateValueAndValidity();
      this.newPasswordForm.controls[
        'newpasswordMatchInput'
      ].updateValueAndValidity();
    }
  }
  validateNewPassword(pass: any): void {
    const userData = {
      otp_code: pass.value.otpcode,
      unique_identifier: this.recoveryPasswrodLookupData.unique_request_id,
      new_password: pass.value.newpasswordInput,
      email_id: this.UserForgotenInput.value,
      company_uuid: this.companyDetails.compDetails.uuid,
    };
    this.isFormSubmitting = true;
    this.authService
      .validateNewpassword(
        userData,
        this.recoveryPasswrodLookupData.staff_id,
        environment.BASE_URL
      )
      .subscribe({
        next: (data: any) => {
          this.isFormSubmitting = false;

          this.passwordChangedSuccess = true;
          this.step.next('step-3');
          setTimeout(() => {
            this.passwordChangedSuccess = false;
          }, 3000);
        },
        error: (error: AppErrors) => {
          this.isFormSubmitting = false;
          this.toastService.showError(error);
          this.cd.detectChanges();
        },
      });
  }

  backtoLogin(): void {
    this.router.navigate(['/auth/login']);
  }
  selectedLang(e: LANGUAGE) {
    this.store.dispatch(SELECT_LANGUAGE({ lang: e }));
  }
  closeSupportDialog(close: boolean) {
    console.log('close', close);
    this.showSupportPopup = false;
  }
  ngOnDestroy(): void {
    this.step.next('step-1');
    this.step.unsubscribe();
  }
}
export function FactoryHttpLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/dist/i18n/', '.json');
}


